import { Snackbar, Alert } from '@mui/material';
import useAppStore from '../store/useAppStore';
import { useShallow } from 'zustand/react/shallow';

export default function Notification() {
  const notification = useAppStore(useShallow((state) => state.notification));
  const clearNotification = useAppStore((state) => state.clearNotification);

  const handleClose = () => {
    clearNotification();
  };

  return (
    <Snackbar
      open={notification.open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={handleClose}
        severity={notification.severity}
        sx={{ width: '100%' }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
}
